import { languageQuery, configQuery } from '@gig/magic-common';
import { LANGUAGE_UPDATED, TRANSLATIONS_LOADED, TRANSLATIONS_QUERY } from '@gig/magic-messages';
import { __awaiter, __generator } from 'tslib';
import { magic } from '@gig/magic-sdk';
import { Language } from '@gig/magic-sdk/dist/adapter/users/language';

var LANGUAGE_CACHE_KEY = 'pw-i18n-{language}-v2';
var TranslationService = /** @class */ (function () {
    function TranslationService() {
        var _this = this;
        configQuery('environment').then(function (environment) {
            _this.environment = environment;
            _this.registerEvents();
            _this.subscribeToLanguageChangeEvent();
        });
    }
    TranslationService.prototype.subscribeToLanguageChangeEvent = function () {
        var _this = this;
        window.eventBus.subscribe(LANGUAGE_UPDATED, function (event) { return __awaiter(_this, void 0, void 0, function () {
            var language, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        language = event.payload;
                        if (!language) {
                            return [2 /*return*/, null];
                        }
                        this.unregisterQueryHandler();
                        _a = this;
                        return [4 /*yield*/, this.getTranslations(language)];
                    case 1:
                        _a.translations = _b.sent();
                        return [4 /*yield*/, languageQuery()];
                    case 2:
                        if ((_b.sent()) === language) {
                            this.registerQueryHandler();
                        }
                        window.eventBus.publish(TRANSLATIONS_LOADED, {
                            translations: this.translations,
                            language: language,
                        });
                        return [2 /*return*/];
                }
            });
        }); }, { replay: true });
    };
    TranslationService.prototype.registerEvents = function () {
        window.eventBus.register(TRANSLATIONS_LOADED, {
            type: 'object',
            properties: {
                translations: {
                    type: 'array',
                },
                language: {
                    type: 'string',
                },
            },
        });
        window.queryBus.register(TRANSLATIONS_QUERY, {
            type: 'string',
            enum: Object.values(Language),
        });
    };
    TranslationService.prototype.unregisterQueryHandler = function () {
        var _a;
        (_a = this.querySubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
    };
    TranslationService.prototype.registerQueryHandler = function () {
        var _this = this;
        this.querySubscription = window.queryBus.subscribe(TRANSLATIONS_QUERY, function () {
            return _this.translations;
        });
    };
    TranslationService.prototype.getTranslations = function (language) {
        return __awaiter(this, void 0, void 0, function () {
            var cachedTranslations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cachedTranslations = this.loadFromCache(language);
                        if (cachedTranslations) {
                            // here we don't await, as we already have them in cache
                            // this is only to refresh the cache
                            this.fetchTranslations(language);
                            return [2 /*return*/, cachedTranslations];
                        }
                        return [4 /*yield*/, this.fetchTranslations(language)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    TranslationService.prototype.fetchTranslations = function (language) {
        return __awaiter(this, void 0, void 0, function () {
            var translations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, magic.methods.translations.fetch(language, this.environment === 'production')];
                    case 1:
                        translations = _a.sent();
                        this.saveIntoCache(language, translations);
                        return [2 /*return*/, translations];
                }
            });
        });
    };
    TranslationService.prototype.saveIntoCache = function (language, translations) {
        try {
            window.localStorage.setItem(LANGUAGE_CACHE_KEY.replace('{language}', language), JSON.stringify(translations));
            return true;
        }
        catch (e) {
            return false;
        }
    };
    TranslationService.prototype.loadFromCache = function (lang) {
        try {
            var item = window.localStorage.getItem(LANGUAGE_CACHE_KEY.replace('{language}', lang));
            return (item && JSON.parse(item)) || null;
        }
        catch (e) {
            return null;
        }
    };
    return TranslationService;
}());

export { LANGUAGE_CACHE_KEY, TranslationService };
